export function isMoreItemsToLoad(numberOfItems: number, items: number): boolean {
    if (items === 0) return false
    return items % numberOfItems === 0
}
